import { GridColumn, IIdentity } from '@grid/models';

/**
 * The options of a column whose value is calculated (a carry-over or a formula)
 * rather than typed, so the user has nothing to do in its cells.
 */
export function getDerivedColumnOptions<T extends IIdentity>(
  isDerived: boolean
): Partial<GridColumn<T>> {
  return isDerived
    ? {
        // Refilling a carry-over or recalculating a formula registers an edit on
        // the row, which would otherwise paint it as an unsaved user change.
        disableChangeHighlighting: true,
        // Treated like the row header: out of the tab order and never shown as focused.
        tabIndex: -1,
        disableFocusedBackground: true,
      }
    : {};
}
